import { Link } from 'gatsby';
import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export interface FeaturesMegaMenuLinksContainerProps {
  isFullWidth?: boolean;
}

export const FeaturesMegaMenuLinksContainer = styled.div<FeaturesMegaMenuLinksContainerProps>`
  width: 100%;
  max-width: ${({ isFullWidth }) => (isFullWidth ? '100%' : '640px')};
  margin: 0 auto;
  box-sizing: border-box;
  padding: 3.5rem 1rem;
  align-self: top;

  .view-all-features {
    width: 100%;
  }

  @media all and (max-width: ${layout.lg}) {
    padding: 0 1rem 1.5rem;

    .feature-links-section-title {
      display: none;
    }
  }

  @media all and (max-width: ${layout.xs}) {
    padding: 0 0 1.5rem;
  }
`;

export const FeaturesMegaMenuLinksContent = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  row-gap: 2rem;
  column-gap: 2.5rem;
  padding: 2rem 0;

  @media all and (max-width: ${layout.lg}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media all and (max-width: ${layout.xs}) {
    grid-template-columns: 1fr;
    row-gap: 0px;
  }
`;

export const FeaturesMegaMenuLink = styled(Link)`
  display: grid;
  row-gap: 4px;
  color: ${palette.greyText};
  text-decoration: none;

  @media all and (max-width: ${layout.xs}) {
    padding: 1rem 0;
    border-bottom: 1px solid ${palette.lightGrayBright};

    &:last-child {
      border-bottom: none;
    }

    .link-subtitle {
      display: none;
    }
  }
`;
